import React from "react";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import OtpInput from "../OtpInput";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import rightTick from "../../../asset/images/rightTick-Circle.svg";
import {
  AESEncryption,
  ApiResDecrypt,
  mobileNumberEnc,
  mobileVal,
} from "../../../CommonMethhods/CommonMethods";
import axios from "axios";
import { Lead_Creation } from "../../../Configuration/API_URL";
import { useEffect } from "react";
import SmallLoader from "../../../Components/Common/smallLoader";

function NonIndividualMobileCard(props) {
  const storeToken = localStorage.getItem("ssoToken");
  const [otpModal, setOtpModal] = useState(false);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(30);
  const [isOtpComplete, setIsOtpComplete] = useState(false);
  const [otpValues, setOtpValues] = useState(Array(4).fill(""));
  const [otpVerified, setOtpVerified] = useState(false);
  const [checkRelation, setCheckRelation] = useState("");
  const [otpLoader, setOtpLoader] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);
  const indiMobileNo = localStorage.getItem("IndiMobileNo")
  const relation = props?.relation;

  const errorSchema = Yup.object().shape({
    mobileValid: Yup.string()
      .required("Please enter mobile number")
      .matches(
        /^[6-9]{1}[0-9]{9}$/,
        "Please enter valid number,Initial digit must range from 6-9"
      ),
  });

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    setError,
    clearErrors,
    reset: resetForm,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(errorSchema),
  });

  
  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

 

  const onHide = () => {
    setOtpModal(false);
  };

  function otpBtn() {
    // sendMobileOtp(getValues("mobileValid"));
  }

  const handleVerifyData = () => {
    if (otpValues?.length === 4) {
    //   validateMobileOtp();
    } else {
      toast.error("Please enter valid OTP");
    }
  };

  const handleOtpComplete = (status) => {
    setIsOtpComplete(status);
  };

  const noVerified = localStorage.getItem("IndiMobileNo");
  const noAlreadyRegis = localStorage.getItem("noAlreadyRegis");
  const saveRelationVal = localStorage.getItem("saveRelationVal");

 

  return (
    <div className="individual-acc-card">
      {/* <form onSubmit={handleSubmit(onFinalSubmit)}> */}
        <div className="card-box">
          {/* {saveRelationVal !== null || noAlreadyRegis === "NO" ? (
            <div className="mobile-verify-sec">
              <label className="mob-card-header">Mobile Verification</label>
              <span className="verify-text">
                Verified
                <img className="verified-success" src={rightTick} />
              </span>
            </div>
          ) : ( */}
            <>
              <label className="mob-card-header">Mobile Verification</label>
              <div className="input-header hni-input-header">
                <label className="input-title">
                  Mobile Number<span style={{ color: "red" }}>*</span>
                </label>
                <div className="text-input">
                  <input
                    type="text"
                    placeholder="Enter mobile number"
                    className="input-st"
                    autoComplete="off"
                    maxLength={10}
                    pattern="[0-9]*"
                    inputMode="numeric"
                    // value={noVerified}
                    // onKeyPress={(e) => mobileVal(e)}
                    // {...register("mobileValid")}
                    // readOnly={otpVerified === true || noVerified?.length === 10}

                    // disabled={otpVerified === true || noVerified?.length === 10}
                  />
                  {/* {noVerified?.length === 10 && (
                    <span className="verify-text">
                      Verified
                      <img className="verified-success" src={rightTick} />
                    </span>
                  )}
                  {errors?.mobileValid && (
                    <p className="forget-link add-error">
                      <span>{errors?.mobileValid?.message}</span>
                    </p>
                  )} */}
                </div>
              </div>
              {/* {(noAlreadyRegis === "YES" || noVerified?.length === 10) && ( */}
                <div className="input-header hni-input-header">
                  <label className="input-title">
                    Select Relationship<span style={{ color: "red" }}>*</span>
                  </label>
                  <div className="text-input">
                    <select
                      className="report-custom-select brokerage-select input-st"
                    //   onChange={(e) => setCheckRelation(e?.target?.value)}
                    //   value={checkRelation}
                    >
                      <option value="">Select</option>
                      {/* {relation &&
                        relation.map((item) => (
                          <option value={item?.name}>{item?.name}</option>
                        ))} */}
                    </select>
                  </div>
                </div>
              {/* )} */}


              {noVerified == null ? (
                  <div
                    className={`${getValues("mobileValid")?.length !== 10 &&
                      noVerified?.length !== 10
                        ? "disable-btn val-btn-wrap"
                        : "val-btn-wrap"
                    }`}
                  >
                    <button
                      type="submit"
                      className={`${
                        getValues("mobileValid")?.length !== 10 &&
                        noVerified?.length !== 10
                          ? "disable-btn validate-btn"
                          : "validate-btn"
                      }`}
                      disabled={
                        getValues("mobileValid")?.length !== 10 &&
                        noVerified?.length !== 10
                      }
                    >
                      {otpLoader ? <SmallLoader /> : <>Validate</>}
                    </button>
                  </div>
                ):
                <div
                  className={`${
                    noVerified?.length !== 10 || checkRelation === ""
                      ? "disable-btn val-btn-wrap"
                      : "val-btn-wrap"
                  }`}
                >
                  <button
                    type="submit"
                    className={`${
                      noVerified?.length !== 10 || checkRelation === ""
                        ? "disable-btn validate-btn"
                        : "validate-btn"
                    }`}
                    disabled={noVerified?.length !== 10 || checkRelation === ""}
                  >
                    {saveLoader ? <SmallLoader /> : <>Save</>}
                  </button>
                </div>
               }
            </>
          {/* )} */}
        </div>
      {/* </form> */}

      <Modal
        show={otpModal}
        // onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="otp-modal setting-model"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="modal-header">
          <Modal.Title id="contained-modal-title-vcenter modal-title">
            <div className="figure-inlac">
              {/* <h2 className="h2-css-all">Enter OTP</h2> */}
            </div>
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={onHide}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="inactive-modal-table otp-modal-body">
            <h2 className="h2-css-all">Enter OTP</h2>
            <div className="wrap-otp-text">
              <p className="otp-text">
                A one-time password has been sent to your mobile number{" "}
                {getValues("mobileValid")?.length === 10 && (
                  <>+91 {mobileNumberEnc(getValues("mobileValid"))}</>
                )}
                <button
                  className="chang-btn"
                  onClick={() => setOtpModal(false)}
                >
                  Change
                </button>
              </p>
            </div>
            <OtpInput
              otpValues={otpValues}
              setOtpValues={setOtpValues}
              onVerify={handleVerifyData}
              otpBtn={otpBtn}
              seconds={seconds}
              minutes={minutes}
              onOtpComplete={handleOtpComplete}
            />

            <div className="nominee-btn-wrapper">
              <div className="default-btn-wrap">
                <button
                  type="submit"
                  className="validate-btn"
                  onClick={() => setOtpModal(false)}
                >
                  Cancel
                </button>
              </div>
              <div
                className={`${
                  !isOtpComplete ? "disable-btn val-btn-wrap" : "val-btn-wrap"
                }`}
              >
                <button
                  type="submit"
                  className="validate-btn"
                  onClick={() => handleVerifyData()}
                  disabled={!isOtpComplete}
                >
                  Proceed
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default NonIndividualMobileCard;
